import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'

import { type ShipperAttachmentDetail } from '../domain/Document'
import { ShipperRepository } from '../infra/ShipperRepository'

export type RetrieveShipperAttachmentParams = {
  shipperUuid: string
  attachmentId: number
}

export type RetrieveShipperAttachmentFactoryDependencies = {
  shipperRepository: ShipperRepository
}

export function retrieveShipperAttachmentFactory({
  shipperRepository,
}: RetrieveShipperAttachmentFactoryDependencies) {
  return async function (
    params: RetrieveShipperAttachmentParams,
    config?: { signal?: AbortSignal }
  ): Promise<ShipperAttachmentDetail> {
    return shipperRepository.retrieveShipperAttachment(
      params.shipperUuid,
      params.attachmentId,
      config
    )
  }
}

export function retrieveShipperAttachment(
  params: RetrieveShipperAttachmentParams,
  config?: { signal?: AbortSignal }
): Promise<ShipperAttachmentDetail> {
  const httpClient = new HttpClient(API_URL)
  const shipperRepository = new ShipperRepository({ httpClient })
  const retrieveFn = retrieveShipperAttachmentFactory({ shipperRepository })
  return retrieveFn(params, config)
}
